import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "../../lib/context/snackbarContext";
import { setCartData } from "../../lib/redux/slices/cartSlice";
import GlobalButton from "./../button/index";
import { appIcons } from "../../assets";
import { t } from "i18next";
import ReactGA from "react-ga4";

const AddToCartBtnStyle = {
  backgroundColor: "text.white",
  borderColor: "text.white",
  boxShadow: "none",
  borderRadius: 0,
  height: 50,
  width: "70%",
  alignSelf: "center",
  color: "#6F6F6F",
};

const AddToCartButton = ({ product, isPurple = true }) => {
  // Hooks
  const { showSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const addedCartRef = useRef(null);
  const detailDialogRef = useRef(null);
  // States
  const [dialogData, setDialogData] = useState(null);
  // Redux states
  const { cartData } = useSelector((state) => state.cartReducer);


  const handleAddToCart = (e, row) => {
    console.log(row,"rowrowrowrowrowrow")
    e.stopPropagation();
    let isSizes = row?.size?.length === 0;
    let isColors = row?.color?.length === 0;
    let isSizesWithColors = row?.sizeWithColor?.length === 0;

    if (isSizes && isColors && isSizesWithColors && row?.quantity === 0) {
      return showSnackbar(t("productOutOfStock"), "error");
    }

    let tempCart = [...cartData];

    if (row?.quantity > 0) {
      const existingProductIndex = tempCart.findIndex(
        (item) => item._id === row._id
      );

      if (existingProductIndex !== -1) {
        const updatedProduct = {
          ...tempCart[existingProductIndex],
          selectedQty: 1,
          // orderStatus:"Pending"
        };
        tempCart[existingProductIndex] = updatedProduct;
      } else {
        tempCart.push({ ...row, selectedQty: 1 });
        ReactGA.event({
          category: "Ecommerce",
          action: "Add to Cart",
          label: row.name.en,
          value: 1,
        });
      }
      localStorage.setItem("cart-data", JSON.stringify(tempCart));
      dispatch(setCartData(tempCart));
      showSnackbar(t("productAddedToCart"), "success");
    }

    if (!isSizes || !isColors || !isSizesWithColors) {
      let tempArray = [];
      row?.galleryImages?.map((val) => {
        tempArray.push({
          original: val,
          thumbnail: val,
        });
      });
      setDialogData({ ...row, galleryImages: tempArray });
      // detailDialogRef.current.openDialog();
    }
  };

  return (
    <>
      {isPurple ? (
        <GlobalButton
          btnText="addCart"
          styleProps={{ width: "100%" }}
          handleClickBtn={(e) => handleAddToCart(e, product)}
        />
      ) : (
        <GlobalButton
          variant={"outlined"}
          startIcon={<img src={appIcons.orangeRedCartIcon} width={18} />}
          btnText={"addCart"}
          handleClickBtn={(e) => handleAddToCart(e, product)}
          styleProps={{
            ...AddToCartBtnStyle,
          }}
        />
      )}
      {/* <AddedCart ref={addedCartRef} />
      <DetailDialog ref={detailDialogRef} dialogData={dialogData} /> */}
    </>
  );
};

export default AddToCartButton;
